import React, { useState, useEffect, useCallback } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
} from "@mui/material";

import roleGroupApi from "../api/roleGroupApi";
import { toast } from "react-toastify";

const PermissionRolePage = React.memo(
  ({ open, onClose, editUserGroupId, dialogTitle }) => {
    const [permissions, setPermissions] = useState([]);

    const fetchPermissions = useCallback(async () => {
      if (!open || !editUserGroupId) return;
      try {
        const response = await roleGroupApi.getRole(editUserGroupId);
        if (response.success) {
          setPermissions(response.data);
        } else {
          toast.error(response.message);
        }
      } catch (err) {
        console.error("Lỗi khi tải dữ liệu quyền:", err);
      } finally {
      }
    }, [open, editUserGroupId]);
    useEffect(() => {
      if (open && editUserGroupId) fetchPermissions();
    }, [open, editUserGroupId, fetchPermissions]);

    const handleTogglePermission = (row_num) => {
      setPermissions((prevPermissions) => {
        return prevPermissions.map((item) =>
          item.row_num === row_num
            ? { ...item, IsApproved: !item.IsApproved }
            : item
        );
      });
    };

    const handleToggleModule = (PvId) => {
      setPermissions((prevPermissions) => {
        const subPermissionsOfModule = prevPermissions.filter(
          (item) => item.PvId === PvId && item.IsMain === false
        );
        if (subPermissionsOfModule.length === 0) return prevPermissions;
        const anySubChecked = subPermissionsOfModule.some(
          (item) => item.IsApproved
        );
        const shouldCheckAll = !anySubChecked;

        return prevPermissions.map((item) => {
          if (item.PvId === PvId && item.IsMain === false) {
            return { ...item, IsApproved: shouldCheckAll };
          }
          return item;
        });
      });
    };

    const areAllSubPermissionsChecked = (PvId) => {
      const subPermissions = permissions.filter(
        (item) => item.PvId === PvId && item.IsMain === false
      );
      if (subPermissions.length === 0) return false;
      return subPermissions.every((item) => item.IsApproved);
    };
    const handleSave = async () => {
      try {
        const dataToSave = permissions.filter(
          (p) => p.IsMain === false && p.IsApproved
        );
        const response = await roleGroupApi.upsertRoleGroup(
          editUserGroupId,
          dataToSave
        );
        if (response.success) {
          onClose();
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error(error);
      }
    };
    // Gom module cha + con thành nhóm
    const groupedPermissions = [];
    permissions.forEach((item) => {
      if (item.IsMain) {
        groupedPermissions.push({
          parent: item,
          children: permissions.filter(
            (p) => p.PvId === item.PvId && p.IsMain === false
          ),
        });
      }
    });

    // Chia nhóm thành 2 cột
    const midIndex = Math.ceil(groupedPermissions.length / 2);
    const col1 = groupedPermissions.slice(0, midIndex);
    const col2 = groupedPermissions.slice(midIndex);

    return (
      <Dialog open={open} maxWidth="lg" fullWidth>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <Divider />
        <DialogContent>
          <div style={{ display: "flex", gap: "20px" }}>
            {[col1, col2].map((col, idx) => (
              <div key={idx} style={{ flex: 1 }}>
                {col.map((group) => (
                  <div
                    key={group.parent.row_num}
                    style={{ marginBottom: "16px" }}
                  >
                    {/* Module cha */}
                    <div
                      style={{
                        fontWeight: "bold",
                        backgroundColor: "#e0eaf3",
                        padding: "6px 10px",
                        borderRadius: "4px",
                        wordBreak: "break-word",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={areAllSubPermissionsChecked(group.parent.PvId)}
                        onChange={() => handleToggleModule(group.parent.PvId)}
                        disabled={group.children.length === 0}
                        style={{ marginRight: "6px" }}
                      />
                      {group.parent.CtrName}
                    </div>

                    {/* Module con */}
                    {group.children.map((child) => (
                      <div
                        key={child.row_num}
                        style={{
                          padding: "4px 10px 4px 30px",
                          backgroundColor: "#f9f9f9",
                          wordBreak: "break-word",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={child.IsApproved}
                          onChange={() => handleTogglePermission(child.row_num)}
                          style={{ marginRight: "6px" }}
                        />
                        {child.CtrName}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button variant="outlined" onClick={onClose}>
            Huỷ
          </Button>
          <Button variant="contained" onClick={handleSave}>
            Lưu thay đổi
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

export default PermissionRolePage;
